import VueKonva from "vue-konva";

export default defineNuxtPlugin(nuxtApp => {
  const { vueApp } = nuxtApp;
  vueApp.use(VueKonva);
});
